<template>
  <div class="page">
    <Header :title="title" :leftHandler="back"></Header>
    <div class="content ">
      <img src="../../assets/images/JD/bg.png" class="content_bg" />
      <div class="content_msg">
        <div class="title1">易加积分</div>
        <div class="title2">{{ parameter.totalPoint }}</div>
        <div class="ul">
          <img src="../../assets/images/JD/bg2.png" class="content_ul_bg" />

          <div class="bom">
            <div class="li1">
              <div class="li_L">订单总积分</div>
              <div class="li_R">{{ parameter.totalPoint }}</div>
            </div>
            <div class="li2">
              <div class="li_L">商品积分</div>
              <div class="li_R">{{ parameter.itemPoint }}</div>
            </div>
            <div class="li2">
              <div class="li_L">运费积分</div>
              <div class="li_R">{{ parameter.freightPoint }}</div>
            </div>
            <div class="hint">订单总积分满5900易加积分即可免京东运费</div>
            <div class="hint2">账户易加积分余额: <p> {{ parameter.clientPoint }}</p>
            </div>
            <div class="btn" @click=" layer = 1">确认支付</div>
          </div>

        </div>
        <!-- <div>parameter:{{ parameter }}</div>
        <div>params:{{ params }}</div> -->
      </div>

    </div>
    <div class="layer_bg" v-if="layer == 1">
      <div class="layer_d">
        <div class="layer_title">是否确认支付?</div>
        <div class="layer_title2">您本次共消耗易加积分:<p>{{ parameter.totalPoint }}</p>
        </div>
        <div class="layer_title3">账户易加积分余额:<p>{{ parameter.clientPoint }}</p>
        </div>
        <div class="layer_btn" @click="remindDelivery()">确认</div>
      </div>

      <img src="../../assets/images/JD/btn-close.png" @click="layer = 0" class="layer_close" />
    </div>
  </div>
</template>

<script>
import wxAppApi from '@/api/wx-app'
import Header from '@/components/header'
// import AddressInfo from '@/components/address-info' 
import { mapState } from 'vuex'
import wx from 'weixin-js-sdk'

export default {
  components: {
    Header,
    // AddressInfo
  },
  data() {
    return {
      title: '收银台',
      parameter: '',
      params: '',
      layer: 0,

    }
  },
  created() {
    var that = this
    // https://extra-wx.hug66.com/v2/jdOrderDetail?clientId=110369&clientPoint=10006401&clientUserId=7620&freightPoint=600&itemPoint=5390&orderId=307226952067&totalPoint=5990
    this.params = this.$route.params
    console.log('this.$route.params===', params)


  },
  mounted() {
    console.log('this.$route.path===', this.$route.path)
    console.log('location.href===', location.href)

    this.getQueryParams(location.href)

  },

  computed: {

  },
  methods: {
    back() {
      this.$dialog.confirm({
        message: '确认要离开易加收银台?',
        confirmButtonText: '继续支付',
        cancelButtonText: '确认离开',

      }).then(() => {
       
      }).catch(() => {
        console.log('error')
        this.$router.go(-1)
      })
    },
    getQueryParams(url) {
      var that = this
      const params = new URLSearchParams(window.location.search);
      var arr = {}

      for (const [key, value] of params) {
        arr[key] = value
      }
      this.parameter = arr
      console.log('this.parameter===', this.parameter)
    },
    remindDelivery() {
      wx.miniProgram.reLaunch({
        url: `/newProject/pay-next/JD-pay?orderId=` + this.parameter.orderId,
        success: function (res) {
          console.log(res)
        },
        fall: function (err) {
          console.log(err)
        }
      })
    }

  }
}
</script>
<style scoped lang="less">



.content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .hint {
    color: #676767;

    font-family: "PingFang SC";
    font-size: 12px;
    margin-top: 24px;
    width: 100%;
    text-align: left;
  }

  .btn {
    border-radius: 58px;
    background: #117281;
    display: flex;
    width: 301px;
    padding: 11px 0px;
    justify-content: center;
    align-items: center;
    color: #FFF;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 21px;
  }

  .hint2 {
    color: #71767C;

    font-family: "PingFang SC";
    font-size: 15px;
    margin-top: 149px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      color: #EB5336;

      font-family: "PingFang SC";
      font-size: 16px;
      margin-left: 5px;
    }
  }

  .content_ul_bg {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
  }

  .ul {
    width: 338px;
    height: 551px;
    border-radius: 12px;
    position: absolute;
    top: 122px;
    margin: 0 auto;

  }

  .li1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 11px;
    height: 23px;
    font-size: 14px;

  }

  .li2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    height: 23px;
    color: #676767;
    font-size: 12px;

  }

  .bom {

    width: 338px;
    padding: 0 21px;
    box-sizing: border-box;
    z-index: 10;
    position: absolute;
    top: 151px;


  }

  .title1 {
    font-size: 15px;
    margin-top: 42px;
    margin-bottom: 9px;
  }

  .title2 {
    color: #EB5336;
    font-family: "PingFang SC";
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .content_bg {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content_msg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

  }

  .icon {
    width: 22.006px;
    height: 20.99px;
    flex-shrink: 0;
    margin-right: 10px;
  }

  .icon2 {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }

  .icon3 {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  .title1 {}

}
</style>
